import { useEffect, useState } from 'react';

const useHover = (ref: any) => {
  const [value, setValue] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (node) {
      const handleMouseOver = () => setValue(true);
      const handleMouseOut = () => setValue(false);

      node.addEventListener('mouseenter', handleMouseOver);
      node.addEventListener('mouseleave', handleMouseOut);

      return () => {
        node.removeEventListener('mouseenter', handleMouseOver);
        node.removeEventListener('mouseleave', handleMouseOut);
        setValue(false);
      };
    } else {
      setValue(false);
    }
  }, [ref]);

  useEffect(() => {
    const handleGlobalMouseMove = (e: MouseEvent) => {
      if (value && ref.current) {
        const rect = ref.current.getBoundingClientRect();
        // Use a small buffer to account for rapid mouse movements
        const buffer = 5;
        const isOutside =
          e.clientX < rect.left - buffer ||
          e.clientX > rect.right + buffer ||
          e.clientY < rect.top - buffer ||
          e.clientY > rect.bottom + buffer;

        if (isOutside) {
          setValue(false);
        }
      }
    };

    if (value) {
      document.addEventListener('mousemove', handleGlobalMouseMove);
    }

    return () => {
      document.removeEventListener('mousemove', handleGlobalMouseMove);
    };
  }, [value, ref]);

  return value;
};

export default useHover;
